import React, { Component } from 'react';
import { Button } from 'semantic-ui-react';
import { withTranslation } from 'react-i18next';

class StroopTest extends Component {
  state = { started: false, countDownValue: 5, permutation: 0, results: [] };

  componentDidMount() {
    this.countDownInterval = setInterval(() => {
      if (this.state.countDownValue <= 0) {
        this.start();
        clearInterval(this.countDownInterval);
      } else this.setState({ countDownValue: this.state.countDownValue - 1 });
    }, 1000);
  }
  start = () => {
    setTimeout(() => {
      this.end();
    }, parseInt((this.props.settings.timeLimit || 30) * 1000));
    this.setState({ started: true });
    this.showNextTest();
  }
  end = () => {
    this.props.onComplete(this.state.results); 
  }
  showNextTest = () => {
    this.testStarted = new Date();
    const { options, permutations } = this.props.settings;
    let { permutation } = this.state;
    if (permutation >= permutations.length) permutation = 0;
    const colour = options[permutations[permutation].colour].colour;
    const colourText = options[permutations[permutation].colour].text;
    const option = options[permutations[permutation].option].text;
    this.setState({ currentColour: colour, currentColourText: colourText, currentOption: option, permutation: permutation + 1 });
  }

  clickOption = (option) => {
    this.testFinished = new Date();
    const results = Object.assign([], this.state.results);
    const { currentOption, currentColour, currentColourText } = this.state;
    results.push({ 
      selectedOption: option,
      displayedOption: currentOption,
      displayedColour: currentColour,
      displayedColourName: currentColourText,
      startTime: this.testStarted, endTime: this.testFinished,
      timeElapsed: this.testFinished - this.testStarted });
    this.setState({ results });
    this.showNextTest();
  }

  render() {
    const { t } = this.props;
    const { started, countDownValue, currentOption, currentColour } = this.state;
    const { options } = this.props.settings;
    return (
      <div>
        {!started ?
          <p style={{fontSize: 100, textAlign: 'center', margin: '50px 0px'}}>{countDownValue}</p>
        :
          <div>
            <p style={{fontSize: 100, textAlign: 'center', margin: '50px 0px', color: currentColour}}>{currentOption}</p>

            <div style={{textAlign: 'center', marginTop: 40}}>
              <p>{t('trial.stage.stroop.whatColour')}</p>
              {options && options.map(o =>
                <Button size='huge' style={{fontSize: 30, margin: 10}} basic content={o.text} onClick={e => this.clickOption(o.text)}/>
              )}
            </div>
          </div>
        }
      </div>
    )
  }
}

export default withTranslation()(StroopTest);
